const options = {
  5: "bg-violet-800/5",
  10: "bg-violet-800/10",
  25: "bg-violet-800/25",
  50: "bg-violet-800/50",
  75: "bg-violet-800/75",
  90: "bg-violet-800/90",
  100: "bg-violet-800",
};

const from = {
  5: "from-violet-800/5",
  10: "from-violet-800/10",
  25: "from-violet-800/25",
  50: "from-violet-800/50",
  75: "from-violet-800/75",
  90: "from-violet-800/90",
  100: "from-violet-800",
};

export default function getBackgroundViolet800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
